export const QUICK_FILTER_API_URL = 'standard-search/topfilter';
export const PA_TOPFILTER_URL = 'prior-authorizations/topfilter/';
export const PA_NOT_APPROVED_REASONS_URL = 'prior-authorizations/topreasons/';
export const PA_NOT_APPROVED_REASONS_BULK_URL = 'prior-auth-bulk-process-jobs/topreasons';
export const PA_CPT_CODES_URL = 'prior-authorizations/cptCodes/';
export const PA_CPT_CODES_BULK_URL = 'prior-auth-bulk-process-jobs/cpt-codes';
